import React, { FC, PropsWithChildren } from 'react';

export const CustomDividerWithText: FC<PropsWithChildren> = ({ children }) => (
  <div className="bh-divider">
    <span>{children}</span>
  </div>
);
